import { FormLabel, Grid, Typography } from '@mui/material';
import { t } from 'i18next';

export interface BakeasyHeaderLabelProps {
  message: string;
  icon?: any;
  style?: React.CSSProperties;
}

function BakeasyHeaderLabel(props: BakeasyHeaderLabelProps) {
  return (
    <Grid sx={{ mb: 1 }} display={'flex'} flexDirection={'row'} alignItems={'center'}>
      {props?.icon && <props.icon />}
      <Typography sx={{ fontSize: 18, fontWeight: 600 }} marginLeft={props?.icon ? 0.5 : 0}>
        {t(props?.message)}
      </Typography>
    </Grid>
  );
}

export default BakeasyHeaderLabel;

export function BakeasyFilterHeaderLabel(props: BakeasyHeaderLabelProps) {
  return (
    <Grid display={'flex'} flexDirection={'row'} alignItems={'center'}>
      {props?.icon && <props.icon />}
      <Typography sx={{ fontSize: 15, fontWeight: 600 }} marginLeft={props?.icon ? 0.5 : 0}>
        {t(props?.message)}
      </Typography>
    </Grid>
  );
}

export function BakeasySubHeaderLabel(props: BakeasyHeaderLabelProps) {
  return (
    <Grid sx={{ mb: 1 }} display={'flex'} flexDirection={'row'} alignItems={'center'}>
      {props?.icon && <props.icon />}
      <Typography sx={{ fontSize: 16, fontWeight: 600 }} marginLeft={props?.icon ? 0.5 : 0}>
        {t(props?.message)}
      </Typography>
    </Grid>
  );
}

export interface BakeasyTitleProp {
  label: string;
  required?: boolean;
}
export function BakeasyTitle(props: BakeasyTitleProp) {
  return (
    <FormLabel sx={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: 0.5 }}>
      {props.label}
      {props?.required ? ' *' : ''}
    </FormLabel>
  );
}
